import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useGidentifyOwnerResultQuery = ({
	id,
	ownerType,
	enabled = true,
}: {
	id: string;
	ownerType: string;
	enabled?: boolean;
}) =>
	useQuery(
		["gidentifyOwnerResult", id, ownerType],
		() => autoChecklistService.getGidentifyOwner(id, ownerType),
		{ retry: 0, cacheTime: 0, enabled: enabled && !!id && !!ownerType },
	);

export default useGidentifyOwnerResultQuery;
